export default class VariousRecordInputsService {
  constructor(http) {
    this.http = http;
  }

  async findAllVariousRecordInputs(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/variousrecordinputs/readall?${queryParams}`, {
      method: "GET",
    });
  }

  // async createVariousRecordInputs(data) {
  //   return this.http.fetch(`/api/variousrecordinputs/create`, {
  //     method: "POST",
  //     body: JSON.stringify(data),
  //   });
  // }

  // async updateVariousRecordInputs(data) {
  //   return this.http.fetch(`/api/variousrecordinputs/update`, {
  //     method: "PUT",
  //     body: JSON.stringify(data),
  //   });
  // }

  // async deleteVariousRecordInputs(data) {
  //   return this.http.fetch(`/api/variousrecordinputs/delete`, {
  //     method: "DELETE",
  //     body: JSON.stringify(data),
  //   });
  // }
}
